import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["removeButton", "fileInput", "fileName", "imagePreview", "removeFlag"];

  declare removeButtonTarget: HTMLButtonElement;
  declare fileInputTarget: HTMLInputElement;
  declare fileNameTarget: HTMLElement;
  declare imagePreviewTarget: HTMLImageElement;
  declare removeFlagTarget: HTMLInputElement;

  updateFileName(): void {
    const files = this.fileInputTarget.files;

    if (files && files.length > 0) {
      this.fileNameTarget.textContent = files[0].name;
    }
  }

  updateImagePreview() : void {
    const files = this.fileInputTarget.files;

    if (files && files.length > 0) {
      const selectedFile = files[0];
      const imgURL = URL.createObjectURL(selectedFile);

      this.imagePreviewTarget.src = imgURL;
    }

    this.removeButtonTarget.disabled = false;
  }

  clearFileInput() : void {
    this.fileInputTarget.value = "";
  }

  removeFileName(): void {
    this.fileNameTarget.textContent = "";
  }

  markForRemoval(): void {
    this.removeFlagTarget.value = "1";
    this.imagePreviewTarget.src = "";
    this.removeButtonTarget.disabled = true;
  }
}
